import apiRequest from './apiRequest';

export type GenerateResourceURLPayload = {
  resourcePath: string; // must start with "share/"
};

export type GenerateResourceURLResponse = {
  uploadURL: string;
  resourcePath: string;
  existingFile: {
    lastModified: string;
    contentLength: number;
    contentType: string;
    eTag: string;
  } | null;
};

export default async function postGenerateResourceURL(
  payload: GenerateResourceURLPayload,
) {
  const { data, error } = await apiRequest<GenerateResourceURLResponse>(
    'user',
    `/admin/generateResourceURL`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );

  return { data, error };
}
